const controller = function (
	$ionicHistory,
	$ionicLoading,
	$ionicScrollDelegate,
	$scope, 
	$state, 
	_,
	Compare,
) {
	'ngInject'

	var vm = this;
	var q;
	var ids;
	
	vm.differences = true;
	vm.init = false;
	vm.showheader = false;
	vm.remove = Compare.remove;
	vm.clear = Compare.clear;

	vm.toProduct = function(uid) {
		$state.go('tab.product', {
			uid: uid,
			ref: 'compare'
		});
	}

	vm.checkDifference = function(a) {

		var difference = false;
		var value;

		var list = [];

		vm.products.forEach(function(product) {
			product.icecat.specifications.forEach(function(specification) {
				specification.attributes.forEach(function(attribute) {
					if (attribute.id === a.id) {
						if (attribute.pair) {
							if (value !== undefined) {
								if (value != attribute.pair.value) {
									difference = true;
								}
							}
							value = attribute.pair.value;
						}
					}
				});
			});
		});

		return difference;
	}
	
	vm.showAttribute = function(a) {

		var value = function(input) {
			if (!input) {
				return input;
			} else {
				return input.value;
			}
		}

		var list = [];

		// get a list of pairs from this attribute
		vm.products.forEach(function(product) {
			product.icecat.specifications.forEach(function(specification) {
				specification.attributes.forEach(function(attribute) {
					if (attribute.id === a.id) {
						list.push(attribute);
					}
				});
			});
		});
		// return true if any of the pairs are set
		return list.filter(x => value(x.pair) !== null).length > 0;

	};
	
	$scope.$on('COMPARE_LIST_CHANGED', function(e, list, action) {
		if ($state.is('tab.compare')) {
			initialize();
		}
		
	});
	
	$scope.$on('COMPARE_LIST_CLEARED', function(e, d) {
		if ($state.is('tab.compare')) {
			$state.go('tab.home');
		}
	});

	function initialize() {

		if (ids !== Compare.string()) {
			$ionicLoading.show();
			ids = Compare.string();

			if (ids) {
				Compare.log({products:ids});
				Compare.get({
					id: ids
				}).then(function(res) {
					vm.products = res;
				}).catch(function() {
					vm.products = false;
				}).finally(() => {
					vm.init = true;
					$ionicLoading.hide();
				});
			} else {
				vm.init = true;
				vm.products = false;
				$ionicLoading.hide();
			}

			
		}
	}

	$scope.$on('$ionicView.enter', function() {
		initialize();
	})

	vm.getScrollPosition = function() {
		var p = $ionicScrollDelegate.getScrollPosition().top > 380;
		if (p !== vm.showheader) {
			vm.showheader = p;
			$scope.$apply();
		}
	}
}

export default controller


// WEBPACK FOOTER //
// ./app/components/compare/compare.controller.js